import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link, useParams, useNavigate } from "react-router-dom";
import Nav from "react-bootstrap/Nav";
import Tab from "react-bootstrap/Tab";
import Layout from "../components/Layout";
import { useDispatch } from "react-redux";
import { listGifts, purchaseGift } from "../redux/actions/profile";
import { toast } from "react-toastify";

export default function DigitalGiftCentre() {
  const [scrolled, setScrolled] = useState(false);
  const [gifts, setGifts] = useState([]);
  const [expandedCards, setExpandedCards] = useState({});
  const dispatch = useDispatch();

  const { id } = useParams();
  const navigate = useNavigate();

  const handleButtonClick = async (gift) => {
    if (id) {
      // Purchase gift if medallion_id exists
      try {
        const payload = {
          gift_id: gift._id,
          medallion_id: id,
          total: 1,
        };
        const response = await dispatch(purchaseGift(payload)).unwrap();
        if (response?.status === 200 && response?.link) {
          window.location.href = response.link;
        } else {
          toast.success(response?.message || "Added to cart successfully!");
        }
      } catch (error) {
        toast.error(error.message || "Failed to purchase gift");
      }
    } else {
      // Navigate to purchase page
      navigate(`/purchase-gift/${gift._id}`);
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      if (scrollTop > 10) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    const fetchGifts = async () => {
      try {
        const response = await dispatch(listGifts());
        if (response.payload) {
          setGifts(response.payload?.data?.gifts);
        }
      } catch (error) {
        console.error("Error fetching gifts:", error);
      }
    };

    fetchGifts();
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [dispatch]);

  return (
    <Layout>
      <section className="profile-banner-sec">
        <Container>
          <div className="recommended-gifts-bnnr mt-5">
            <h1>Send a Symbol of Love</h1>
            <p>Explore a curated collection of digital gifts</p>
            <button>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="17"
                height="20"
                viewBox="0 0 17 20"
                fill="none"
              >
                <path
                  d="M16.7489 11.9716L8.54188 20L0.334873 11.9716C0.238042 11.8991 0.158185 11.807 0.100707 11.7015C0.0432297 11.596 0.00947369 11.4796 0.00172405 11.3601C-0.00602559 11.2407 0.0124126 11.121 0.0557898 11.0092C0.0991671 10.8974 0.166471 10.796 0.253145 10.712C0.339819 10.628 0.443839 10.5633 0.558164 10.5222C0.67249 10.4812 0.79445 10.4647 0.915789 10.4741C1.03713 10.4834 1.15501 10.5182 1.26146 10.5763C1.36791 10.6343 1.46044 10.7141 1.53279 10.8104L7.6923 16.817V0.835423C7.6923 0.613855 7.78181 0.401363 7.94113 0.24469C8.10046 0.0880184 8.31656 0 8.54188 0C8.76721 0 8.9833 0.0880184 9.14263 0.24469C9.30196 0.401363 9.39147 0.613855 9.39147 0.835423V16.817L15.551 10.8104C15.711 10.6542 15.9275 10.5668 16.1529 10.5676C16.3784 10.5684 16.5943 10.6572 16.7531 10.8145C16.912 10.9718 17.0008 11.1848 17 11.4065C16.9992 11.6282 16.9089 11.8405 16.7489 11.9967V11.9716Z"
                  fill="#373737"
                />
              </svg>
            </button>
          </div>
        </Container>
      </section>
      <section className="recommended-gifts-sec p-80">
        <Container>
          <div className="recommended-gifts-title">
            <div>
              <h2>Recommended Gifts </h2>
              <p>
                Thoughtful digital gestures that honor love, comfort hearts, and
                keep memories blooming.
              </p>
            </div>
            {/* <button>
              View All
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="17"
                viewBox="0 0 20 17"
                fill="none"
              >
                <path
                  d="M11.9716 0.251107L20 8.45812L11.9716 16.6651C11.8991 16.762 11.807 16.8418 11.7015 16.8993C11.596 16.9568 11.4796 16.9905 11.3601 16.9983C11.2407 17.006 11.121 16.9876 11.0092 16.9442C10.8974 16.9008 10.796 16.8335 10.712 16.7469C10.628 16.6602 10.5633 16.5562 10.5222 16.4418C10.4812 16.3275 10.4647 16.2056 10.4741 16.0842C10.4834 15.9629 10.5182 15.845 10.5763 15.7385C10.6343 15.6321 10.7141 15.5396 10.8104 15.4672L16.817 9.3077L0.835422 9.3077C0.613855 9.3077 0.401363 9.2182 0.24469 9.05887C0.0880181 8.89954 -3.63528e-07 8.68344 -3.73378e-07 8.45812C-3.83227e-07 8.23279 0.088018 8.0167 0.24469 7.85737C0.401363 7.69804 0.613855 7.60853 0.835422 7.60853L16.817 7.60853L10.8104 1.44902C10.6542 1.28904 10.5668 1.07251 10.5676 0.847062C10.5684 0.621611 10.6572 0.405713 10.8145 0.246857C10.9718 0.0880036 11.1848 -0.000791164 11.4065 6.09768e-06C11.6282 0.000801452 11.8405 0.0911258 11.9967 0.251107L11.9716 0.251107Z"
                  fill="white"
                />
              </svg>
            </button> */}
          </div>
          <div className="recommended-gifts-box">
            {gifts?.map((gift, index) => {
              const description =
                gift.description ||
                "A beautiful digital gift to share with loved ones.";
              const isExpanded = expandedCards[index];
              const shouldTruncate = description.length > 80;
              const displayText =
                shouldTruncate && !isExpanded
                  ? description.slice(0, 80) + "..."
                  : description;

              return (
                <div className="recommended-gifts-item" key={index}>
                  <img
                    src={
                      gift.image || require("../assets/images/sarahjohnson.png")
                    }
                    alt={gift.name}
                  />
                  <h3>{gift.name || "Gift Item"}</h3>
                  <p>
                    {displayText}
                    {shouldTruncate && (
                      <span
                        onClick={() =>
                          setExpandedCards((prev) => ({
                            ...prev,
                            [index]: !prev[index],
                          }))
                        }
                        style={{
                          color: "#C4A574",
                          cursor: "pointer",
                          marginLeft: "5px",
                          fontWeight: "500",
                        }}
                      >
                        {isExpanded ? "Show less" : "Show more"}
                      </span>
                    )}
                  </p>
                  <div className="recommended-gifts-price">
                    <h4>
                      ${gift.price || "9.99"}
                      {/* <span>
                        {gift.discount
                          ? `(${gift.discount}% off)`
                          : "(60% off)"}
                      </span> */}
                    </h4>
                    {/* <div className="recommended-gift-stars">
                      <p>{gift.rating || "4"}</p>
                      <ul>
                        {[...Array(5)].map((_, i) => (
                          <li key={i}>
                            <img
                              src={require("../assets/images/star.svg").default}
                              alt="star"
                            />
                          </li>
                        ))}
                      </ul>
                    </div> */}
                  </div>
                  <button onClick={() => handleButtonClick(gift)}>
                    {id ? "Buy Now" : "Try Now"}
                  </button>
                </div>
              );
            })}
          </div>
        </Container>
      </section>
    </Layout>
  );
}
